import { useState } from "react";
import { useProfile } from "../context/ProfileContext";
import { ArrowUpRight, Menu, X } from "lucide-react";

export default function Header({ onContactClick }) {
  const PROFILE = useProfile();
  const [open, setOpen] = useState(false);
  const links = [
    { label: "Vitals", href: "#vitals" },
    { label: "Profile", href: "#profile" },
    { label: "Reel", href: "#reel" },
    { label: "Film", href: "#film" },
    { label: "Schedule", href: "#upcoming" },
    { label: "Press", href: "#press" },
    { label: "Contact", href: "#contact" },
  ];

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-black/60 border-b border-white/10"
      data-testid="site-header"
    >
      <div className="max-w-screen-2xl mx-auto px-6 sm:px-8 lg:px-12 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3 group" data-testid="header-logo">
          <span className="inline-block w-2 h-2 bg-[#E60000]" />
          <span className="font-display font-black tracking-tight uppercase text-white text-lg leading-none">
            {PROFILE.firstName} <span className="text-[#8A8A8A]">Ahyi-Sena</span>
          </span>
          <span className="hidden sm:inline text-[10px] tracking-[0.25em] uppercase text-[#8A8A8A] border-l border-white/10 pl-3 ml-1">
            MB · C/O 2027
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-xs tracking-[0.22em] uppercase text-[#8A8A8A] hover:text-white transition-colors"
              data-testid={`nav-${l.label.toLowerCase()}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={onContactClick}
            className="hidden sm:inline-flex items-center gap-2 bg-[#E60000] hover:bg-[#FF3333] text-white px-4 py-2 text-xs tracking-[0.22em] uppercase font-bold transition-colors"
            data-testid="header-contact-cta"
          >
            Contact Coach
            <ArrowUpRight size={14} strokeWidth={2.5} />
          </button>
          <button
            className="md:hidden text-white"
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-black" data-testid="mobile-menu">
          <div className="px-6 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-sm tracking-[0.22em] uppercase text-[#8A8A8A] hover:text-white py-2"
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
